export interface ClothingSelectOption {
  value: string;
  label: string;
}

export const CLOTHING_SEASONS: ClothingSelectOption[] = [
  { value: 'SUMMER', label: 'CLOTHING_SEASON_SUMMER' },
  { value: 'WINTER', label: 'CLOTHING_SEASON_WINTER' },
  { value: 'ALL_SEASON', label: 'CLOTHING_SEASON_ALL_SEASON' }
];

export const CLOTHING_MARKER_TYPES: ClothingSelectOption[] = [
  { value: 'DEPARTMENT', label: 'CLOTHING_MARKER_DEPARTMENT' },
  { value: 'JOB', label: 'CLOTHING_MARKER_JOB' }
];

export const CLOTHING_MENU_OPTIONS = {
  settings: 'clothing-settings',
  assignments: 'clothing-assignments',
  report: 'clothing-report'
};

export const CLOTHING_ADMIN_ROUTES = {
  settings: '/dashboard/admin/clothing',
  assignments: '/dashboard/admin/clothing/assignments',
  report: '/dashboard/admin/clothing/report'
};

export const STOREKEEPER_SEARCH_PARAMS = {
  limit: 100,
  offset: 1,
  status: [],
  language: [],
  searchFilter: '',
  dateRange: {
    startDate: '',
    endDate: ''
  },
  sort: {
    sortField: 'lastName',
    order: 'ASC'
  },
  roles: ['ROLE_STOREKEEPER'],
  departments: [],
  positions: []
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing.constants.ts